import { useParams } from "react-router";
import RenderRoot from "../core/RenderRootApp";
export default function () {
  const params = useParams<{ appId: string }>();
  return <RenderRoot appId={params.appId}></RenderRoot>;
}
